module.exports = __webpack_public_path__ + "static/img/login_logo.861e94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/login_logo.png
// module id = kk1P
// module chunks = 38